if($(".logo__slider_main .logo-list").length) {
  $(".logo__slider_main .logo-list").each(function (slider) {
    $(this).slick({
      centerMode: true,
      centerPadding: "10px",
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: true,
            centerMode: true,
            centerPadding: "10px",
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            arrows: true,
            centerMode: true,
            centerPadding: "10px",
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    });
  });
}

// if ($(".blog-post-list").length) {
//   $(".blog-post-list").each(function () {
//     $(this).slick({
//       centerMode: true,
//       centerPadding: 10,
//       margin: 10,
//       slidesToShow: 3,
//       slidesToScroll: 1,
//       arrows: true,
//       responsive: [
//         {
//           breakpoint: 768,
//           settings: {
//             arrows: true,
//             centerMode: true,
//             centerPadding: '10px',
//             slidesToShow: 2,
//             slidesToScroll: 1
//           }
//         },
//         {
//           breakpoint: 480,
//           settings: {
//             arrows: true,
//             centerMode: true,
//             centerPadding: '10px',
//             margin: '10px',
//             slidesToShow: 1,
//             slidesToScroll: 1
//           }
//         }
//       ]
//     });
//   });
// }